import DataTable from "datatables.net-dt"
import "datatables.net-responsive-dt"

const form = document.querySelector("#labels-form")
const tableElement = jQuery("#labels-datatable")

const LabelsTable = {
	init: () => {
		if (!form || !tableElement) return
		let table = new DataTable(tableElement, {
			// disable XX posts per page select field
			lengthChange: false,
			columns: [{ name: "name" }, { name: "label" }, { name: "zip_code" }, { name: "city" }, { name: "validity_rights" }, { name: "mention" }],
			// enable responsive stacking
			responsive: {
				breakpoints: [
					{ name: "desktop", width: Infinity },
					{ name: "tablet-l", width: 1024 },
					{ name: "tablet-p", width: 768 },
					{ name: "mobile-l", width: 480 },
					{ name: "mobile-p", width: 320 },
				],
				details: {
					display: jQuery.fn.dataTable.Responsive.display.childRowImmediate,
					type: "none",
					target: -1,
				},
			},
			// remove "showing xx of xx results"
			info: false,
			// remove bottom pagination
			paging: false,
			// remove search feature
			searching: false,
			// translations
			language: {
				emptyTable: "Aucune donnée disponible",
				// search: "Recherche : ",
			},
		})

		/**
		 * Handle Form
		 */
		const select = form.querySelector("select")

		LabelsTable.reOrder(table, select)

		form.addEventListener("change", function(e) {
			if (select.contains(e.target)) {
				LabelsTable.reOrder(table, select)
			} else {
				form.submit()
			}
		})
	},

	reOrder: (table, select) => {
		let selected_order = select.options[select.selectedIndex].value
		if (selected_order) table.order([{ name: selected_order, dir: "asc" }]).draw()
	},
}

export default LabelsTable
